import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NavbarComponent } from "./Main/Components/navbar/navbar.component";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AgGridModule } from "ag-grid-angular";
import "ag-grid-enterprise";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { MyDatePickerModule } from "mydatepicker";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LoginComponent } from "./Main/Components/login/login.component";
import { GlobalApp } from "./Main/Helpers/global";
import { NgxSpinnerModule } from "ngx-spinner";
import { ComponentSecurityRevisionsComponent } from "./Main/Components/component-security-revisions/component-security-revisions.component";
import { ComponentSecurityValidators } from "./Main/Components/component-security-revisions/component-security-validators";
import { UdcRevisionsComponent } from "./Main/Components/udc-revisions/udc-revisions.component";
import { UdcValidators } from "./Main/Components/udc-revisions/udc-validators";
import { CompanyMasterRevisionsComponent } from "./Main/Components/company-master-revisions/company-master-revisions.component";
import { CompanyMasterValidators } from "./Main/Components/company-master-revisions/company-master-validators";
import { UserMasterRevisionsComponent } from "./Main/Components/user-master-revisions/user-master-revisions.component";
import { UserMasterValidators } from "./Main/Components/user-master-revisions/user-master-validators";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown";
import { SharedModule } from "./shared.module";
import {
  IgxInputGroupModule,
  IgxDatePickerModule,
  IgxComboModule,
  IgxGridModule,
  IgxDropDownModule,
  IgxToggleModule,
  IgxSelectModule,
  IgxTabsModule,
  IgxDialogModule,
  IgxAutocompleteModule,
  IgxSwitchModule,
  IgxDividerModule,
  IgxCardModule,
} from "igniteui-angular";
import { MenuSecurityRevisionsComponent } from "./Main/Components/menu-security-revisions/menu-security-revisions.component";
import { MenuSecurityListComponent } from "./Main/StatelessComponents/menu-security-list/menu-security-list.component";
import { MenuSecurityFormComponent } from "./Main/StatelessComponents/menu-security-form/menu-security-form.component";
import { MenuSecurityCopyComponent } from "./Main/StatelessComponents/menu-security-copy/menu-security-copy.component";
import { PrintFolderRevisionsComponent } from "./Main/Components/print-folder-revisions/print-folder-revisions.component";
import { PrintFolderListComponent } from "./Main/StatelessComponents/print-folder-list/print-folder-list.component";
import { B2bLoginComponent } from "./Main/Components/b2b-login/b2b-login.component";
import { HomeComponent } from "./Main/Components/home/home.component";
import { EmployeeMasterRevisionsComponent } from "./Main/Components/employee-master-revisions/employee-master-revisions.component";
import { EmployeeMasterValidators } from "./Main/Components/employee-master-revisions/employee-master-validators";
import { BasicAuthInterceptor } from "./base-auth.interceptor";

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    LoginComponent,
    ComponentSecurityRevisionsComponent,
    UdcRevisionsComponent,
    CompanyMasterRevisionsComponent,
    UserMasterRevisionsComponent,
    MenuSecurityRevisionsComponent,
    MenuSecurityListComponent,
    MenuSecurityFormComponent,
    MenuSecurityCopyComponent,
    PrintFolderRevisionsComponent,
    PrintFolderListComponent,
    B2bLoginComponent,
    HomeComponent,
    EmployeeMasterRevisionsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MyDatePickerModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    AgGridModule.withComponents([]),
    NgxSmartModalModule.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      progressBar: true,
      closeButton: true,
    }),
    AngularMultiSelectModule,
    SharedModule,
    IgxInputGroupModule,
    IgxDatePickerModule,
    IgxComboModule,
    IgxGridModule,
    IgxDropDownModule,
    IgxToggleModule,
    IgxSelectModule,
    IgxTabsModule,
    IgxDialogModule,
    IgxAutocompleteModule,
    IgxSwitchModule,
    IgxDividerModule,
    IgxCardModule,
  ],
  providers: [
    GlobalApp,
    ComponentSecurityValidators,
    UdcValidators,
    CompanyMasterValidators,
    UserMasterValidators,
    EmployeeMasterValidators,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BasicAuthInterceptor,
      multi: true, // Allows multiple interceptors to be registered
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
